// Per-environment settings, fetched at startup from /config.json so the same
// static build runs against dev or prod. Nothing here is secret: the app runs in
// a browser, so its users can see all of it.

export type AppConfig = {
  apiUrl: string;
  cognitoRegion: string;
  cognitoClientId: string;
  // Dev only: demo sign-ins use passwords while SES can mail only verified
  // addresses. Real portal users have codes only.
  allowPassword?: boolean;
};

export async function loadConfig(): Promise<AppConfig> {
  const res = await fetch("/config.json", { cache: "no-store" });
  if (!res.ok) {
    throw new Error("config.json is missing: run ./scripts/portal-app-config.sh first");
  }
  const raw = (await res.json()) as Partial<AppConfig>;
  for (const key of ["apiUrl", "cognitoRegion", "cognitoClientId"] as const) {
    if (typeof raw[key] !== "string" || !raw[key]) throw new Error(`config.json has no ${key}`);
  }
  return {
    ...(raw as AppConfig),
    apiUrl: (raw.apiUrl as string).replace(/\/$/, ""),
    allowPassword: raw.allowPassword === true,
  };
}
